//include 8
jQuery(function(){
    $("body").on("click","[data-scroll-to]",function(e){
        e.preventDefault();

        var selector = $(e.target).data("scroll-to") || $(this).data("scroll-to");

        if(!selector) {
            return;
        }

        var additionalOffset = $(e.target).data("offset") || $(this).data("offset") || 0;
        window.pixelpoint.utilities.scrollTo(selector,false,additionalOffset);
    });

    var initialScrollTos = $("[data-initial-scroll-to]");
    if(initialScrollTos.length > 0){
        var additionalOffset = initialScrollTos.first().data("offset") || 0;
        window.pixelpoint.utilities.scrollTo(initialScrollTos.first(),false,additionalOffset);
    }

    //****************we link the paginations**********************************************************
    $("body").on("click","ul.result-pagination a", function(){
        var parent = $(this).closest(".tx-dce-pi1");
        window.pixelpoint.utilities.scrollTo(parent,false,0);
    });
    /*
    $("ul.result-pagination").on("click","a",function(){
        var parent = $(this).closest(".tx-dce-pi1");
        window.pixelpoint.utilities.scrollTo(parent,false,0);
    });
    //*/
    //*************************************************************************************************
});